import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.MENU.TEXT',
        isTitle: true
    },
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'bx bx-home-circle',
        link: '/',

    },
    {
        id: 2,
        label: 'MENUITEMS.FINDFORCAR.TEXT',
        icon: 'bx bxs-car',
        link: '/cars',
    },
    {
        id: 2,
        label: 'MENUITEMS.ValidateParking.TEXT',
        icon: 'bx bx-selection',
        link: '/parkings-validated',
    },
    // {
    //     id: 2,
    //     label: 'Checkers',
    //     icon: 'bx bx-user-check',
    //     link: '/checkers',
    // },
    // {
    //     id: 3,
    //     label: 'Merchant Categories',
    //     icon: 'dripicons-user',
    //     link: '/merchant-categories',
    // },
    // {
    //     id: 4,
    //     label: 'Merchants',
    //     icon: 'dripicons-user-group',
    //     link: '/merchants',
    // },
    // {
    //     id: 5,
    //     label: 'Transactions',
    //     icon: 'bx bx-list-ol',
    //     link: '/transaction',
    // },
    // {
    //     id: 2,
    //     label: 'DB Users',
    //     icon: 'mdi mdi-database-lock-outline',
    //     link: '/db-users',
    // },
    // {
    //     id: 2,
    //     label: 'API Generation',
    //     icon: 'bx bx-code-alt',
    //     link: '/api',
    // },
    // {
    //     id: 9,
    //     label: 'System Settings',
    //     icon: 'bx bx-cog',
    //     link: '/settings',

    //     // subItems: [
    //     //     {
    //     //         id: 13,
    //     //         label: 'Settings',
    //     //         link: '/point-settings',
    //     //         parentId: 9
    //     //     },
    //     //     {
    //     //         id: 13,
    //     //         label: 'Transactions',
    //     //         link: '/point-transactions',
    //     //         parentId: 9
    //     //     },
    //     // ]
    // },
 
];

